/*
    Přidání kategorie
*/
import React,{ Component,Fragment } from 'react';
import {Mutation,Query} from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import Modal from 'react-modal';
import { Editor } from '@tinymce/tinymce-react';
import {ADD_EDIT_MEMBERSHIP,GET_MEMBERSHIPS,GET_MEMBERSHIP} from '../Queries/index.js';
import { withApollo } from 'react-apollo';
import Notification from '../../../Library/notification';
import Helper from '../../../Library/helper';
import MembershipLib from '../Library/membership';


const INITIAL_STATE = {
    err:"",
    formData:{
        membershipDurationID:0,
        length:0,
        active:1,
        autoPaymentsNumber:0,
        langs:[],
        selectedLang:'cz',
        selectedCurrency:'Kč',
    },
    allVats:[],
    allLanguageMutations:[]
}

class AddEditMembership extends Component{

    constructor(props){
        super(props);
        this.state = INITIAL_STATE;
        
        this.membershipLib = new MembershipLib(this); 
    }

    componentDidMount(){
        this.membershipLib.getData();
    }    

    render(){

        var {err}               = this.state;
        var {selectedMembershipID,listVariables} = this.props;

        return(

            <Mutation 
                mutation={ADD_EDIT_MEMBERSHIP}
                errorPolicy = "all"
                update = {async (cache, response) => {
                    this.membershipLib.updateList(cache,response,selectedMembershipID,listVariables);

                    let notify = new Notification();

                    if(selectedMembershipID && selectedMembershipID != 0) notify.setNotification(cache,'Úspěšně uloženo',true,false);
                    else notify.setNotification(cache,'Úspěšně přidáno',true,false);

                }}

                onCompleted = {() => {
                    this.props.openCloseModal(false);
                }}
                
            >
            {
                (addEditMembership,{loading, error}) => {

                    const {active,selectedLang,selectedCurrency,autoPaymentsNumber,length} = this.state.formData;
                    const {allLanguageMutations,allVats} = this.state;
                    
                    if(error){
                        const helper = new Helper(); 
                        err = helper.getApolloErrorText(error);
                    }

                    return(
                        <Modal
                            className="Modal__Bootstrap modal-dialog modal-lg"
                            closeTimeoutMS={150}
                            isOpen={true}
                            onRequestClose={() => this.props.openCloseModal(false)}
                        >
                            <div className="modal-content">
                                <div className="modal-header d-flex align-items-center">
                                    <h4 className="modal-title">{(selectedMembershipID && selectedMembershipID != 0 ? "Úprava členství / produktu" : "Přidání členství / produktu")}</h4>
                                    <div className="ml-auto">
                                        <select className="form-control" name="selectedLang" onChange={(e) => this.membershipLib.formLangObjectHandle(e)}>
                                            {allLanguageMutations && allLanguageMutations.map((item,index) => (
                                                <option key={index} value={item.languageID}> {item.suffix} </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button type="button" className="close ml-3" onClick={() => this.props.openCloseModal(false)}>                                    
                                        <span aria-hidden="true">x</span>
                                        <span className="sr-only">Close</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    {err ?
                                        <Error text={err} />
                                    :
                                        <Fragment>
                                            {!loading ?
                                            <div className="row">  
                                                <div className="col-12">
                                                    <label className="input-label">Aktivní</label>
                                                    <div className="form-group">
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" name="active" id="active1" value="1" checked={(active == 1 ?  true : false)} onChange={(e) => this.membershipLib.formHandle(e)} />
                                                            <label className="form-check-label" htmlFor="active1">
                                                                Ano
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input className="form-check-input" type="radio" name="active" id="active2" value="0" checked={(active == 0 ?  true : false)} onChange={(e) => this.membershipLib.formHandle(e)} />
                                                            <label className="form-check-label" htmlFor="active2">
                                                                Ne
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>              
                                                <div className="col-12 col-sm-6">
                                                    <label className="input-label">Název členství / produktu ({selectedLang})</label>
                                                    <div className="form-group">
                                                        <input className="form-control" type="text" name="name" value={this.membershipLib.getLangValue("name")} onChange={(e) => this.membershipLib.formLangHandle(e)} />
                                                    </div>
                                                </div>  
                                                <div className="col-12 col-sm-3">
                                                    <label className="input-label">Cena ({selectedLang})</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="number" step=".1" name="value" value={this.membershipLib.getLangValue("value")} onChange={(e) => this.membershipLib.formLangHandle(e)} />
                                                        
                                                        <div className="input-group-append">
                                                            <span className="input-group-text">{selectedCurrency}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-3">
                                                    <label className="input-label">DPH ({selectedLang})</label>
                                                    <div className="input-group">
                                                        <select value={this.membershipLib.getLangValue("vat")} className="form-control" name="vat" onChange={(e) => this.membershipLib.formLangHandle(e)}>
                                                            {allVats && allVats.map((item,index) => (
                                                                <option key={index} value={item.value}>{item.value} %</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-4">
                                                    <label className="input-label">Krátký popis ({selectedLang})</label>
                                                    <div className="form-group">
                                                        <input className="form-control" type="text" name="description" value={this.membershipLib.getLangValue("description")} onChange={(e) => this.membershipLib.formLangHandle(e)} />
                                                    </div>
                                                </div>

                                                <div className="col-12 col-sm-3">
                                                    <label className="input-label">Délka členství </label>
                                                    <div className="form-group">
                                                        <input className="form-control" type="text" name="length" value={length} onChange={(e) => this.membershipLib.formHandle(e)} />
                                                    </div>
                                                </div> 

                                                <div className="col-12 col-sm-3">
                                                    <label className="input-label">Počet automatických plateb </label>
                                                    <div className="form-group">
                                                        <input className="form-control" type="text" name="autoPaymentsNumber" value={autoPaymentsNumber} onChange={(e) => this.membershipLib.formHandle(e)} />
                                                    </div>
                                                </div> 

                                                <div className="col-12">
                                                    <label className="input-label">Text emailu ({selectedLang})</label>
                                                    <div className="form-group">
                                                        <Editor
                                                            name="emailText"
                                                            apiKey = '9z3phhnyq7jkeeqztql1euovfotvpd2gdduygtdpk14wu4ij'
                                                            value={this.membershipLib.getLangValue("emailText")}
                                                            init={{
                                                                plugins: 'link code paste emoticons',
                                                                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | formatselect | link | blockquote | emoticons | code',
                                                                paste_as_text: true,
                                                                language_url : '/langs/cs.js',
                                                                language: "cs",
                                                            }}
                                                            onEditorChange={(content) => this.membershipLib.formLangHandleEditor(content,"emailText")}
                                                        />
                                                    </div>
                                                </div>

                                                                                                
                                            </div>

                                            :

                                            <Loading />  

                                            }  
                                        </Fragment>
                                    }
                                            
                                </div>
                                <div className="modal-footer"> 
                                    {!loading && <button type="button" className="btn btn-primary flex-fill" onClick={() => this.membershipLib.addMembership(addEditMembership)}>{(selectedMembershipID && selectedMembershipID != 0 ? "Upravit" : "Přidat")}</button>}
                                    <button type="button" className="btn btn-danger" onClick={() => this.props.openCloseModal(false)}>Zavřít</button>
                                </div>
                            </div>
                        </Modal>
                    );

                }
            }
            </Mutation>
        
        );

    }

}

export default withApollo(AddEditMembership);